import { render, staticRenderFns } from "./proNarrate.vue?vue&type=template&id=82fdf96c&scoped=true"
import script from "./proNarrate.vue?vue&type=script&lang=js"
export * from "./proNarrate.vue?vue&type=script&lang=js"
import style0 from "./proNarrate.vue?vue&type=style&index=0&id=82fdf96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fdf96c",
  null
  
)

export default component.exports